import { useContext, useEffect, useMemo, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { isValidArray } from "../../Layout/Common/common";
import { ProductCardAlgolia } from "../../Layout/Common/productCardAlgolia";
import { ProductCarouselSection } from "../../Layout/Common/productCarouselSection";
import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";

const MAX_FEATURED_ITEMS = 8;

export const FeaturedProducts = () => {
  const [productHit, setProductHit] = useState(null);
  const { algoliaProducts } = useContext(GlobalContext);
  useEffect(() => {
    if (algoliaProducts && isValidArray(algoliaProducts["TRENDINGPRODUCTS"])) {
      setProductHit(algoliaProducts["TRENDINGPRODUCTS"]);
    } else {
      // fetchClearanceProductsAlgolia();
    }
  }, [algoliaProducts]);

  const featured = useMemo(
    () => (isValidArray(productHit) ? productHit.slice(0, MAX_FEATURED_ITEMS) : []),
    [productHit],
  );

  return (
    <ProductCarouselSection
      title="Featured Products"
      headerAction={
        <Link to={PAGES.FEATUREDPRODUCTS} className="text-decoration-underline text-uppercase">
          View All
        </Link>
      }
      sectionClassName="feature-section"
      items={featured}
      getItemKey={(item, idx) => item?.key ?? `featured-${idx}`}
      renderItem={(item) => <ProductCardAlgolia data={item} />}
    />
  );
};
